// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import PeopleSearchController from "./people_search_controller"
application.register("people-search", PeopleSearchController)

import ComposerController from "./composer_controller"
application.register("composer", ComposerController)

import NewPostsController from "./new_posts_controller"
application.register("new-posts", NewPostsController)

import ReplyFormController from "./reply_form_controller"
application.register("reply-form", ReplyFormController)

import MultiselectController from "./multiselect_controller"
application.register("multiselect", MultiselectController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)
